module.exports = __webpack_public_path__ + "img/1584656618550718353.8b162263.jpg";